import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'
import { SearchQuery, SearchItem } from '../../../model/search/search-query'
import fetchStatement from './fetch-statement'
import fetchStatements from './fetch-statements'
import authStore from '@/store/auth/auth-store'
import feedStore from '@/store/feed/feed-store'

export default async function setStatementQuery(context: BareActionContext<StatementState, RootState>)
{
    if(feedStore.feedId) {
        console.log('setStatementQuery: getting single statement = %j', feedStore.feedId)
        fetchStatement(context, feedStore.feedId)
        return
    }

    const searchForm = statementStore.state.statementSearchForm
    let query = new SearchQuery()
    query.sort = ['createdAt']
    query.descending = true

    let createdBy: string | null = null
    const tags = searchForm.tags
    console.log('setStatementQuery: feed user = %j', feedStore.state.feedUserId)
    console.log('setStatementQuery: auth user = %j', authStore.state.user)

    if (searchForm.createdByUser && feedStore.feedUserId) createdBy = feedStore.feedUserId.toString()
    else if (searchForm.createdByFollowing) createdBy = 'followed'
    else if (searchForm.createdByMe) createdBy = 'me'

    if (createdBy) {
        query.searchItems.push(new SearchItem('createdby', 'id', createdBy, null, null, null))
    }

    if (searchForm.jybedByUser && feedStore.feedUserId) {
        query.searchItems.push(new SearchItem('jybedby', 'id', feedStore.feedUserId.toString(), null, null, null))
    } 

    if (searchForm.jybedByFollowing) {
        query.searchItems.push(new SearchItem('jybedby', 'id', 'followed', null, null, null))
    }

    if (searchForm.notReactedByMe) {
        query.searchItems.push(new SearchItem('jybedby', 'id', 'me', null, null, null, true))
        query.searchItems.push(new SearchItem('consideredby', 'id', 'me', null, null, null, true))
        query.searchItems.push(new SearchItem('ignoredby', 'id', 'me', null, null, null, true))
    }

    if (searchForm.jybedByMe) {
        query.searchItems.push(new SearchItem('jybedby', 'id', 'me', null, null, null))
    } 

    if (searchForm.consideredByMe) {
        query.searchItems.push(new SearchItem('consideredby', 'id', 'me', null, null, null))
    } else {
        query.searchItems.push(new SearchItem('consideredby', 'id', 'me', null, null, null, true))
    }

    if (searchForm.ignoredByMe) {
        query.searchItems.push(new SearchItem('ignoredby', 'id', 'me', null, null, null))
    } else {
        query.searchItems.push(new SearchItem('ignoredby', 'id', 'me', null, null, null, true))
    }
  
    for(let i=0; i<tags.length; i++) {
        query.searchItems.push(new SearchItem('hastag', 'name', tags[i], null, null, null))
    }
    statementStore.commitSetQuery({ query: query })
    fetchStatements(context)

    return
}
